import React from 'react'
import "./ChinaTours.scss"
import Topbar from "../../components/TopbarChina/Topbar";
import Footer from "../../components/Footer/Footer"
import Card from "../../components/Card/Card";
import ToursSlider from '../../components/ToursSlider/ToursSlider';
import cities from "../china-cities/ data";


const ChinaTours = () => {
  return (
    <div className='tours-box'>
      <Topbar bgColor={true} />
      <ToursSlider tours={cities}/>
      
      {/* <div className="tours-cards">
      {Array.from({length:4}).map((el)=> <Card title="5 дней 6 ночей тур Пекин"
          url="/cities/beijing.jpg"/>)}
          </div>

      
      <Footer/> */}
      <Footer/>
      
    </div>
  )
}

export default ChinaTours
